import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { getTestIds } from 'seagull/utils/TestIds';
import { useResponsive } from '~/client-flow/contexts';
import { useOverlayContext } from '~/contexts';
import { useOnMount } from '~/hooks/useOnMount';
import { CoverPageDesktop } from './CoverPageDesktop';
import { CoverPageMobile } from './CoverPageMobile';
export const GetCoverPageTID = (parentTestId)=>getTestIds({
        parentTestId
    });
export const CoverPage = (param)=>{
    let { testId, relationship, onGetStarted, isPreview, showRecipientToast } = param;
    const { CoverPageTestIds } = useMemo(()=>GetCoverPageTID(testId), [
        testId
    ]);
    const { isMobile } = useResponsive();
    const buyerName = "".concat(relationship.buyer.firstName || '', " ").concat(relationship.buyer.lastName || '').trim();
    const { showInfoToast } = useOverlayContext();
    useOnMount(()=>{
        if (showRecipientToast) {
            showInfoToast("You're reviewing the proposal as ".concat(buyerName), CoverPageTestIds.RecipientToast());
        }
    });
    if (isMobile) {
        return /*#__PURE__*/ _jsx(CoverPageMobile, {
            testId: testId,
            relationship: relationship,
            onGetStarted: onGetStarted,
            isPreview: isPreview
        });
    }
    return /*#__PURE__*/ _jsx(CoverPageDesktop, {
        testId: testId,
        relationship: relationship,
        onGetStarted: onGetStarted,
        isPreview: isPreview
    });
};
